module.exports = __webpack_public_path__ + "img/team-list2.d0a26032.png";